export const GROUP_KEY_SEPARATOR = '|';
